<template>
  <v-card flat :class="{ 'grey--text': disabled }">
    <v-card-title class="card-bg-2 headline">
      <v-flex style="flex: 0 0 130px; align-items: baseline; display: flex;">
        Stations
        <v-menu v-model="showHelp" offset-y open-on-hover :open-delay="400">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="showHelp = true" class="clickable ml-2" color="primary">
              info_outline
            </v-icon>
          </template>
          <v-card>
            <v-card-text> The stations shown contain at least one of the selected time series. </v-card-text>
          </v-card>
        </v-menu>
      </v-flex>
      <!-- <v-spacer />
      <v-text-field :disabled="disabled" :loading="isSearching" class="rounded emphasize-clear" prepend-inner-icon="search" v-model="search" clearable solo placeholder="Search time series stations" hide-details>
      </v-text-field> -->
    </v-card-title>
    <!-- <div class="card-bg-2 default-border-bottom scroll-border-bottom">
      <v-item-group mandatory v-model="filterToggle" active-class="white--text">
        <v-subheader style="display: inline; cursor: default;">Show:</v-subheader>
        <v-item>
          <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">Available</v-chip>
        </v-item>
        <v-item>
          <v-chip small slot-scope="{ active, toggle }" :color="active ? 'primary' : 'default'" :selected="active" class="chipFilter" @click="toggle">
            <div style="float: left;" class="pr-2" :class="{ 'info--text font-weight-bold': stationsLength > 0 }">
              {{ stationsLength }}
            </div>
            Selected
          </v-chip>
        </v-item>
      </v-item-group>
    </div> -->
    <v-card-text class="pa-0">
      <SelectContinuousStationComponents ref="selectStationComponents" @loading="$emit('loading', $event)" :search="search" :timeSeriesStations="timeSeriesStations" :selection="selection" :disabled="disabled" @selected="onSelectedStationComponents" :filterToggle="filterToggle" :filterToggles="filterToggles" :selectionCount="stationsLength" :stations="stations" @isSearching="issearching = $event" @missingStationIds="$emit('missingStationIds', $event)" />
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'


  import SelectContinuousStationComponents from './SelectContinuousStationComponents'

  const filterToggles = {
    available: 0,
    selected: 1,
    unavailable: 2,
  }


  const dataSources = createNamespacedHelpers('datasource')

  export default {
    components: {
      SelectContinuousStationComponents,
    },
    props: {
      stationsMediaTypes: Object,
      timeSeriesStations: Array,
      selection: Object,
      index: Number,
      disabled: Boolean,
    },
    data() {
      return {
        filterToggles,
        filterToggle: filterToggles.available,
        showHelp: false,
        isSearching: false,
        search: '',
        stationComponents: {},
        isScrolling: false,
        selectedStations: [],
      }
    },
    computed: {
      ...dataSources.mapGetters(['dataSources']),
      // discreteStations() {
      //   return this.dataSources[SOURCE_TYPES.discreteEnvirodata]
      // },
      stations() {
        let stations = []
        if (!this.discreteStations || !this.stationsMediaTypes) return stations
        return stations
      },
      canContinue() {
        return this.selectedStations && this.selectedStations.length
      },
      stationsLength() {
        return this.selectedStations.length
      },
    },
    watch: {
    },
    methods: {
      clearSearch() {
        this.search = ''
      },
      emitUpdate(value) {
        this.$emit('stations', value)
      },
      onSelectedStationComponents(value) {        
        var stationIds = []
        Object.entries(value).forEach(st => {
          if(st[1]) {
            stationIds.push(Number(st[0]))
          }
        })
        var matchedStations = this.timeSeriesStations.filter(x => stationIds.indexOf(x.Id) >= 0)
        this.selectedStations = matchedStations
        //console.log('selected stations are ' + matchedStations)
        this.emitUpdate(matchedStations)
      },
      selectStationIds(stationIds) {
        if (stationIds && stationIds.length > 0) this.filterToggle = this.filterToggles.selected
        else this.filterToggle = this.filterToggles.available

        this.clearSearch()

        this.$refs.selectStationComponents.selectStationIds(stationIds)
      },
    },
  }
</script>